export default __webpack_public_path__ + "static/pathway-2-a9e9f78f03be1b03676b4252d293b83e.jpg";